import {
	createPageLoadMetric,
	PUBLIC_LINK_SHARED_PAGE_LOAD_KEY,
	PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY,
} from '@confluence/browser-metrics';

export const PUBLIC_LINK_SHARED_PAGE_LOAD = createPageLoadMetric({
	key: PUBLIC_LINK_SHARED_PAGE_LOAD_KEY,
});

export const PUBLIC_LINK_SITE_SETTING_PAGE_LOAD = createPageLoadMetric({
	key: PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY,
});
